import React, { FunctionComponent, useEffect } from 'react';
import css from './MentionsOfficialAccountCommentRoute.module.less';
import MentionsOfficialAccountSelector from '@components/MentionsOfficialAccountSelector';
import MentionsOfficialAccountCommentList from '@components/MentionsOfficialAccountCommentList';
import useMentionsOfficialAccountFilters from '@hooks/useMentionsOfficialAccountFilters';

interface MentionsOfficialAccountCommentRouteProps {}

const MentionsOfficialAccountCommentRoute: FunctionComponent<
  MentionsOfficialAccountCommentRouteProps
> = () => {
  const { getList } = useMentionsOfficialAccountFilters();

  useEffect(() => {
    getList();
  }, []);

  return (
    <div className={css.root}>
      <div>
        <MentionsOfficialAccountSelector />
      </div>
      <MentionsOfficialAccountCommentList />
    </div>
  );
};

export default MentionsOfficialAccountCommentRoute;
